<pr-form
  (onSubmit)="onSubmit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
  [formWithTabs]="true"
  (nextTab)="nextTab()"
  [tabChanged]="tabChanged"
  [noSubmitBtn]="form.controls.productType.value === null"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="onCancel()"
    ></pr-icon>
  </button>

  @if (!entity.productType) {
    <div
      class="form-step form-step-before"
      [ngClass]="{ left: form.controls.productType.value != null }"
    >
      <h3 class="drawer-title">Types de placements</h3>
      <ul>
        @for (product of products; track product) {
          <li
            class="pointer choose-button"
            (click)="selectProductType(product.id)"
          >
            {{ product.label }}
          </li>
        }
      </ul>
    </div>
  }
  <div
    class="form-step"
    [ngClass]="{ right: form.controls.productType.value == null }"
  >
    <pr-tabs
      clazz="drawer-tab-button"
      [defaultTextColor]="false"
      [changeTab]="changeTab"
      (lastTab)="onTabChange($event)"
    >
      <pr-tab label="Informations générales">
        <input formControlName="id" type="hidden" />

        <pr-input-autosuggest
          formControlName="managerProviderId"
          label="Établissement bancaire ou assurance"
          [options]="managers"
          [derrors]="derrors"
          [optionLabel]="'label'"
        >
          <span customOptionText
            >Ce partenaire sera créé lors de l'enregistrement.</span
          >
        </pr-input-autosuggest>

        <pr-input [label]="'Nom du placement'" [derrors]="derrors">
          <input formControlName="label" type="text" />
        </pr-input>

        <pr-input [label]="'Montant actuel'" [suffix]="'€'" [derrors]="derrors">
          <input formControlName="lastValue" type="text" />
        </pr-input>

        <pr-input
          [label]="'Versement mensuel'"
          [suffix]="'€'"
          [derrors]="derrors"
        >
          <input formControlName="monthlyPayment" type="text" />
        </pr-input>

        <pr-input-date
          formControlName="startDate"
          label="Date d’acquisition"
          [derrors]="derrors"
        ></pr-input-date>
      </pr-tab>
      <pr-tab label="Détention">
        <pr-input label="Acquis au travers de" [derrors]="derrors">
          <mat-select formControlName="subscriptionSource">
            @for (item of sources; track item) {
              <mat-option [value]="item.id">
                {{ item.label }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input-owner-share
          formControlName="owners"
          [derrors]="derrors"
        ></pr-input-owner-share>
      </pr-tab>
    </pr-tabs>
  </div>
</pr-form>
